import '../styles/NotFound.css'
import goalNotFound from '../images/goal-not-found.svg'

interface Props {
  setOpenAddNewCommonGoal?: (open: boolean) => void
}

export default function GoalNotFound({ setOpenAddNewCommonGoal }: Props) {
  return (
    <div className="GoalNotFound">
      <img src={goalNotFound} alt='There are no goals to display.'/>
      {setOpenAddNewCommonGoal && <button onClick={() => setOpenAddNewCommonGoal(true)}>Add New Common Goal</button>}
    </div>
  )
}